import { NavigationCategory, NavigationItem } from "./config";

const sortByOrder = <T extends { order?: number }>(items: T[]) =>
  [...items].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

export const hasAnyPermission = (
  userPermissions: string[],
  required?: string[]
): boolean => {
  if (!required || required.length === 0) return true;
  return required.some((p) => userPermissions.includes(p));
};

export function getFirstAllowedRouteByPermissions(
  navigation: NavigationCategory[],
  permissions: string[] | undefined,
  locale: string
): string | null {
  const userPermissions = permissions ?? [];

  for (const category of sortByOrder(navigation)) {
    if (!hasAnyPermission(userPermissions, category.allowedPermissions)) continue;

    for (const item of sortByOrder(category.items)) {
      if (hasAnyPermission(userPermissions, item.allowedPermissions)) {
        return `/${locale}${item.route}`;
      }
    }
  }

  return null;
}

export function resolveNavigation(
  navigation: NavigationCategory[],
  permissions: string[] | undefined,
  locale: string,
  translate: (key: string) => string
): NavigationCategory[] {
  const userPermissions = permissions ?? [];

  return navigation
    .map((category) => {
      if (!hasAnyPermission(userPermissions, category.allowedPermissions)) return null;

      const items = category.items
        .filter((item) => hasAnyPermission(userPermissions, item.allowedPermissions))
        .map((item: NavigationItem) => ({
          ...item,
          label: translate(item.label),
          route: `/${locale}${item.route}`,
        }))
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

      if (items.length === 0) return null;

      return {
        ...category,
        label: translate(category.label),
        items,
      };
    })
    .filter(Boolean)
    .sort((a, b) => (a!.order ?? 0) - (b!.order ?? 0)) as NavigationCategory[];
}
